import { add } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

import { CodingPeriodInfo } from '@/types/logs'

export const COMBINED_LOGS_COLUMNS = {
    Code: 'code',
    Reference: 'reference',
    Routes: 'routes',
    Trip: 'trip',
    Run: 'run',
    Duty: 'duty',
    Fleet: 'fleet',
    Location: 'location',
    Description: 'description',
    Delay: 'delay',
    Milage: 'mileage',
    Author: 'author',
    OriginalAuthor: 'originalAuthor',
    Time: 'time',
    Deadline: 'deadline',
    Timestamp: 'timestamp',
    Unfinished: 'unfinished',
    Actions: 'actions',
    LogActions: 'logActions',
    Flag: 'flag',
    Lock: 'lock',
} as const

export const DEFAULT_CODING_PERIOD: CodingPeriodInfo = {
    codingPeriod: 'LogCreation',
    permissions: ['View', 'Create', 'Update', 'Delete', 'Duplicate'],
    deadline: formatInTimeZone(add(new Date(), { days: 7 }), 'UTC', "yyyy-MM-dd'T'HH:mm:ss"),
}
